import { Link } from "react-router-dom";

const quickLinks = [
  { label: "首页", to: "/" },
  { label: "电影", to: "/category/电影" },
  { label: "电视剧", to: "/category/电视剧" },
  { label: "短视频", to: "/category/短视频" },
  { label: "App下载", to: "/download" },
  { label: "关于我们", to: "/about" },
];

export default function Footer() {
  return (
    <footer className="bg-primary-950 border-t border-primary-900/60 mt-auto">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 md:gap-8">
          <div className="md:col-span-2 max-w-md">
            <div className="flex items-center gap-2">
              <span className="w-9 h-9 rounded-lg bg-primary-500 text-background-950 flex items-center justify-center">
                <i className="ri-play-fill text-xl" />
              </span>
              <span className="font-heading font-bold text-lg text-foreground-950">黄瓜视频App</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-foreground-300">
              黄瓜视频App官方网站，专注于高清视频播放与下载支持。这里汇集影视剧与精彩短视频内容预览，
              帮助你快速了解 App 特色并完成下载安装。
            </p>
            <p className="mt-4 text-xs text-foreground-500 leading-relaxed">
              站内视频封面与简介均为演示内容，播放功能为前端演示，不含真实视频流。
            </p>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-foreground-900 mb-4">
              <a href="#footer-nav" className="hover:text-primary-400 transition-colors">网站导航</a>
            </h4>
            <ul id="footer-nav" className="grid grid-cols-2 gap-2.5">
              {quickLinks.map((l) => (
                <li key={l.to}>
                  <Link to={l.to} className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-foreground-900 mb-4">
              <a href="#footer-contact" className="hover:text-primary-400 transition-colors">联系我们</a>
            </h4>
            <ul id="footer-contact" className="space-y-3 text-sm text-foreground-300">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line w-5 h-5 flex items-center justify-center text-primary-400" />
                <a href="mailto:support@huanggua-video.example.com" className="hover:text-primary-400 transition-colors">
                  support@huanggua-video.example.com
                </a>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-customer-service-2-line w-5 h-5 flex items-center justify-center text-primary-400" />
                <span>客服电话：400-000-0000</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-time-line w-5 h-5 flex items-center justify-center text-primary-400" />
                <span>服务时间：每日 09:00 - 21:00</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-primary-900/60 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-foreground-400">
          <span>© 2026 黄瓜视频App官方网站. 保留所有权利.</span>
          <span>本站为演示站点，不提供真实视频播放与下载服务。</span>
        </div>
      </div>
    </footer>
  );
}